// @flow
import React from 'react'
import ToggleButton from 'react-toggle-button'

type Props = {
  onToggle: Function,
  value: boolean,
}
const Switch = ({onToggle, value}: Props) => {
  return (
    <ToggleButton
      inactiveLabel={''}
      activeLabel={''}
      thumbStyle={{
        position: 'absolute',
        width: 30,
        height: 30,
        boxShadow: `0 0 2px rgba(0,0,0,.12),0 2px 4px rgba(0,0,0,.24)`,
        borderRadius: 15,
        alignItems: 'center',
        justifyContent: 'center',
      }}
      colors={{
        active: {
          base: `rgb(84, 185, 72)`,
        },
        inactive: {
          base: `rgb(198, 198, 198)`,
        },
      }}
      trackStyle={{
        height: 20,
      }}
      thumbAnimateRange={[0, 22]}
      value={value}
      onToggle={onToggle}
    />
  )
}

export default Switch



// WEBPACK FOOTER //
// ./src/admin/components/Switch.js